import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const post = (state) => _.get(state, 'post')
const posts = (state) => _.get(state, 'posts')
const total = (state) => _.get(state, 'total')
const postsByAuthor = (state) => _.get(state, 'postsByAuthor')
const isPopularAuthorLoading = (state) => _.get(state, 'popularAuthorsLoading')
const popularAuthors = (state) => _.get(state, 'popularAuthors')
const postErrors = (state) => _.get(state, 'errors')
const isCommentLoading = (state) => _.get(state, 'commentLoading')
const isCommentAdding = (state) => _.get(state, 'commentAdding')
const isCommentUpdating = (state) => _.get(state, 'commentUpdating')
const comments = (state) => _.get(state, 'comments')
const postsByLocation = (state) => _.get(state, 'postsByLocation')
const isPostsByLocationLoading = (state) => _.get(state, 'postsByLocationLoading')
const featuredPost = (state) => _.get(state, 'featuredPost')
const isFeaturedPostLoading = (state) => _.get(state, 'featuredPostLoading')
const violationsList = (state) => _.get(state, 'violations')
const isFileLoading = (state) => _.get(state, 'fileLoading')
const postFile = (state) => _.get(state, 'uploadFile')
const pageCount = (state) => _.get(state, 'pageCount')
const postNotFound = (state) => _.get(state, 'postNotFound')

export default {
	isLoading,
	post,
	posts,
	total,
	postErrors,
	postsByAuthor,
	isCommentLoading,
	popularAuthors,
	isPopularAuthorLoading,
	isCommentUpdating,
	isCommentAdding,
	comments,
	postsByLocation,
	isPostsByLocationLoading,
	featuredPost,
	isFeaturedPostLoading,
	violationsList,
	isFileLoading,
	postFile,
	pageCount,
	postNotFound
}
